var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUlettiLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 636.422,
    height: 636.421,
    viewBox: "0 0 636.422 636.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_667",
    "data-name": "Rectangle 667",
    width: 636.422,
    height: 636.421,
    fill: "#0c31ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11695",
    "data-name": "Path 11695",
    d: "M317.323,0C142.071,0,0,142.07,0,317.323S142.071,634.645,317.323,634.645s317.323-142.07,317.323-317.323S492.576,0,317.323,0M420.6,449.551H214.053a31.1,31.1,0,0,1-30.628-36.529l35.814-202.247a31.106,31.106,0,0,1,30.63-25.681H391.1a31.106,31.106,0,0,1,30.78,26.615l29.494,202.247A31.1,31.1,0,0,1,420.6,449.551",
    transform: "translate(0 1.775)",
    fill: "#0c31ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUlettiLogo);
export default __webpack_public_path__ + "static/media/uletti-logo.3f115db3fecd780403adb309c47ecb6f.svg";
export { ForwardRef as ReactComponent };